import styled from 'styled-components';

export const ToggleButtonContainer = styled.div`
  min-width: 200px;
  width: 200px;
`;
